const keyPrefix = 'cwcalc';

const storage = window.localStorage || { setItem: () => {}, getItem: () => {} };

const prefixKey = (key) => {
  return `${keyPrefix}.${key}`;
};

export const save = (key, obj) => {
  storage.setItem(prefixKey(key), JSON.stringify(obj));
};

export const restore = (key) => {
  return JSON.parse(storage.getItem(prefixKey(key)) || null);
};
